import { useState, useCallback } from "react";

// Small hook to manage per-field validation errors and clear them on edit.
export function useFormErrors() {
  const [errors, setErrors] = useState({});
  const clearErr = useCallback(
    (k) => setErrors((er) => { if (!er[k]) return er; const n = { ...er }; delete n[k]; return n; }),
    []
  );
  return { errors, setErrors, clearErr };
}
